import cx from "classnames";
import gsap, { Power4 } from "gsap";
import React, { useRef, useState } from "react";
import { ReactComponent as ChevronDown } from "./../../assets/icons/chevron-down.svg";
import { ReactComponent as ChevronUp } from "./../../assets/icons/chevron-up.svg";
import styles from "./Accordion.module.scss";
import { useGSAP } from "@gsap/react";

const Accordion = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const contentRef = useRef(null);
    useGSAP(() => {
        if (!isOpen) {
            gsap.to(contentRef.current, {
                height: 0,
                duration: 0.3,
                ease: Power4.easeInOut,
            });
        } else {
            gsap.to(contentRef.current, {
                height: "auto",
                duration: 0.3,
                ease: Power4.easeInOut,
            });
        }
    }, [isOpen]);

    const toggleHandler = (e) => {
        setIsOpen(!isOpen);
    };

    return (
        <div
            className={cx(
                styles.accordion,
                {
                    [styles["is--active"]]: isOpen,
                },
                {
                    [styles["group-filter"]]: props.group
                },
                {
                    [styles["sort-button"]]: props.additionalClass,
                },
            )}
        >
            <div className={styles.panel}>
                <div className={styles["panel-title"]} onClick={toggleHandler}>
                    {props.header}
                    {!isOpen ? <ChevronDown /> : <ChevronUp />}
                </div>
                <div className={styles["panel-content"]} ref={contentRef}>
                    {props.children}
                </div>
            </div>
        </div>
    );
};

export default Accordion;
